import styled from 'styled-components';
import theme from 'src/theme';

export const ResetColumnsButton = styled.button`
    padding: 4px 12px;
    background-color: ${theme.colors.background.white};
    color: ${theme.colors.text.black};
    border: 1px solid ${theme.colors.border.mediumGrey};
    border-radius: 4px;
    font-size: 0.85rem;
    height: 32px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: ${theme.colors.shadow.lightGrey} 0px 2px 3px -1px;
    transition: background-color 0.2s ease;
    flex: 1;

    &:hover {
        background-color: ${theme.colors.background.hover.default};
    }

    &:active {
        box-shadow: inset ${theme.colors.shadow.lightGrey} 0px 1px 1px;
        transform: translateY(1px);
    }

    .icon {
        margin-left: 8px;
    }
`;

export const ButtonWrapper = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
`;
